import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import {
  useClipQualitySettingsModal,
  useClipSettingsModal,
  useCs2HudSettingsModal,
} from "MVVM/Hooks/useClipQualitySettingsModal";
import { Cs2HudSettingsModal } from "MVVM/Components/Cs2HudSettings";
import { usePortal } from "MVVM/Hooks/usePortal";
import { UnifiedUpgradeModal } from "MVVM/Components/Modals/UnifiedUpgradeModal";
import { ClipSettingsModal } from "MVVM/Components/ClipSettingsModal";
import { TTierKey } from "MVVM/Views/Pricing/Components/PricingCards/types";
import { ClipQualitySettingsModal } from "./index";

const MODAL_QUERY_PARAM = "clip-quality-settings";

export const ClipQualitySettingsModalRenderer = () => {
  const { isOpen, open, close } = useClipQualitySettingsModal();
  const { isOpen: hudOpen, close: closeHud } = useCs2HudSettingsModal();
  const {
    isOpen: clipSettingsOpen,
    open: openClipSettings,
    close: closeClipSettings,
  } = useClipSettingsModal();
  const [upgradeTier, setUpgradeTier] = useState<TTierKey>("PRO");

  const {
    portalOpen: upgradeModalOpen,
    setPortalOpen: setUpgradeModalOpen,
    Portal: UpgradeModalPortal,
  } = usePortal(
    <UnifiedUpgradeModal
      featureName="Higher Quality Clips"
      upgradeAction="Get higher quality clips"
      requiredTierKey={upgradeTier}
      analyticsSource="Clip Quality Settings"
      initialPlan={upgradeTier}
      onClose={() => setUpgradeModalOpen(false)}
    />,
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.has(MODAL_QUERY_PARAM)) {
      open();

      params.delete(MODAL_QUERY_PARAM);
      const remaining = params.toString();
      const newUrl =
        window.location.pathname + (remaining ? `?${remaining}` : "");
      window.history.replaceState({}, "", newUrl);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleUpgradeRequired = (tierKey: string) => {
    setUpgradeTier(tierKey as TTierKey);
    close();
    setTimeout(() => setUpgradeModalOpen(true), 150);
  };

  const handleAllSettings = () => {
    close();
    setTimeout(() => openClipSettings(), 150);
  };

  const handleAllSettingsFromHud = () => {
    closeHud();
    setTimeout(() => openClipSettings(), 150);
  };

  return (
    <>
      {isOpen &&
        createPortal(
          <ClipQualitySettingsModal
            onClose={close}
            onUpgradeRequired={handleUpgradeRequired}
            onAllSettings={handleAllSettings}
          />,
          document.getElementById("root") || document.body,
        )}
      {hudOpen &&
        createPortal(
          <Cs2HudSettingsModal
            onClose={closeHud}
            onAllSettings={handleAllSettingsFromHud}
          />,
          document.getElementById("root") || document.body,
        )}
      {upgradeModalOpen && UpgradeModalPortal}
      {clipSettingsOpen && <ClipSettingsModal onClose={closeClipSettings} />}
    </>
  );
};
